<template>
  <div
    @click="handleClick"
    class="hover:bg-gray-100 p-2 rounded cursor-pointer darkitem"
  >
    <slot />
  </div>
</template>

<script setup>
import { inject } from 'vue'

const props = defineProps({
  value: {
    type: [String, Number, Object],
    required: true
  }
})

const select = inject('dropdownSelect')

function handleClick() {
  if (select) {
    select(props.value)
  }
}
</script>

<style lang="scss" scoped>
@media (prefers-color-scheme: dark) {
  div.darkitem {
    @apply text-gray-700;
  }
}
</style>
